export default __webpack_public_path__ + "static/media/FRA.6455f145.svg";